<div class="flex flex-col h-full">
  <!-- Waiting for the server -->
  <div *ngIf="!isPageReady" class="flex flex-col flex-1 gap-3 items-center justify-center">
    <p-progressSpinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '44px', height: '44px' }"></p-progressSpinner>
    <span class="text-sm" style="color: var(--p-text-muted-color)">The system adds up the shipments.</span>
  </div>

  <ng-container *ngIf="isPageReady">
    <!-- Range Selector -->
    <div class="p-2 border-b shrink-0">
      <p-dropdown
        [options]="weeksOptions"
        [(ngModel)]="weeksBack"
        optionLabel="label"
        optionValue="value"
        (onChange)="onWeeksChange()"
        styleClass="w-full"
      ></p-dropdown>
    </div>

    <!-- Totals for the selected range -->
    <div class="grid grid-cols-3 gap-2 px-3 py-2 shrink-0 border-b">
      <div>
        <div class="text-xs" style="color: var(--p-text-muted-color)">Shipped Revenue</div>
        <div class="text-lg font-semibold">{{ totalRevenueAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
      </div>
      <div>
        <div class="text-xs" style="color: var(--p-text-muted-color)">Total Shipments</div>
        <div class="text-lg font-semibold">{{ totalShipmentCount | number }}</div>
      </div>
      <div>
        <div class="text-xs" style="color: var(--p-text-muted-color)">Revenue / Shipment</div>
        <div class="text-lg font-semibold">{{ revenuePerShipmentAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
      </div>
    </div>

    <!-- Chart -->
    <div class="flex-1 min-h-0">
      <ag-charts *ngIf="options" [options]="options" style="width: 100%; height: 100%; display: block"></ag-charts>
      <div *ngIf="!options" class="flex items-center justify-center h-full text-sm"
           style="color: var(--p-text-muted-color)">
        No shipment left in the last {{ weeksBack }} weeks.
      </div>
    </div>
  </ng-container>
</div>
